module.exports = __webpack_public_path__ + "static/media/flash1.31a21676.svg";